import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ILeague } from '../../models/league.model';


@Component({
  selector: 'app-league-popup',
  templateUrl: './league-popup.component.html',
  styleUrls: ['./league-popup.component.css'],
})
export class LeaguePopupComponent {
  league: ILeague = {
    id: -1,
    name: '',
    minimumAge: null,
    rating: 0,
    registrationStartDate: null,
    registrationEndDate: null,
    startDate: null,
    endDate: null,
    playoff: false,
    playoffStartDate: null,
    playoffEndDate: null,
    leagueType: '',
    teamSize: 0,
    gender: '',
    menSinglesCount: 0,
    womenSinglesCount: 0,
    menDoublesCount: 0,
    womenDoublesCount: 0,
    mixedDoublesCount: 0,
    maxNumberOfTeams: 0,
    clubId: -1,
    fees: 0,
    canRegister: false,
    isRegistered : false,
    noOfRegisteredTeams : 0
  };

  constructor(public dialogRef: MatDialogRef<LeaguePopupComponent>, @Inject(MAT_DIALOG_DATA) public existingLeague: ILeague) {
    if (existingLeague) {
      this.league = existingLeague;
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  leagueTypeChange(): void {
    if (this.league.leagueType == 'S') {
      this.league.teamSize = 1;
    } else if (this.league.leagueType == 'D') {
      this.league.teamSize = 2;
    } else {
      this.league.teamSize = 0;
    }

  }
}